import { GET_BRANDS, GET_MATERIAL, GET_MATERIALS, GET_MATERIALS_ERR, FILTER_MATERIALS, COUNT_MATERIALS, SET_SORT, POST_COMMENT_MATERIAL, POST_RATE_MATERIAL, GET_NEW_ARRIVALS, GET_BEST_SELLERS, SET_PAGE, GET_TOP_BRAND_MATERIALS, DELETE_COMMENT, GET_TRENDY_PRODUCTS, GET_COMMENT_ORDER, TEST_PRO, UPDATE_MATERIAL_PRICE } from './type';
import { ADD_WISHLIST, DELETE_WISHLIST } from '../profile/type';
import { GET_PROMOTION_SECTION, GET_PROMOTION_SECTION_1, GET_PROMOTION_SECTION_2, GET_PROMOTION_SECTION_3, GET_PROMOTION_SECTION_4, GET_PROMOTION_SECTION_5, GET_PROMOTION_SECTION_6, GET_PROMOTION_SECTION_7, GET_PROMOTION_SECTION_8, GET_PROMOTION_SECTION_9, GET_PROMOTION_SECTION_10 } from './type'
// import moment from 'moment';
// import TestPro from '../../views/TestPro';
import _ from 'lodash'

// let pro_start_date = moment().startOf('month').format('YYYY-MM-DD');
// let pro_end_date = moment().endOf('month').format('YYYY-MM-DD');

export function getBrands(filter = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_BRANDS,
            payload: []
        });
        axios.get(`/api/v2/brand`, {
            params: {
                filter: filter,
            }
        })
            .then((response) => {
                dispatch({
                    type: GET_BRANDS,
                    payload: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_BRANDS,
                    payload: []
                });
            })
    }
}

export function setFilter(filter) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: FILTER_MATERIALS,
            payload: filter
        });
    }
}

export function clearFilters() {
    return (dispatch, getState) => {
        dispatch({
            type: FILTER_MATERIALS,
            payload: {}
        });
    }
}

export function setSort(sortField) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SET_SORT,
            payload: sortField,
        })
    }
}

export function getNewArrivals() {
    return (dispatch, getState, { axios }) => {
        axios.post(`/api/v2/materials`, {
            sort: { value: 'new_arrivals' },
            limit: 20
        })
            .then((response) => {
                dispatch({
                    type: GET_NEW_ARRIVALS,
                    payload: response.data
                });
            })
            .catch((error) => {
                // dispatch({
                //     type: GET_NEW_ARRIVALS_ERR,
                //     payload: typeof error.response === "undefined"? "Some error has occurred.": error.response.data
                // });
            })
    }
}

export function getBestSellers(filter, options) {
    return (dispatch, getState, { axNL }) => {
        return new Promise(resolve => {
            const newOptions = options ? Object.assign({}, options) : {}
            if (filter.item_id) {
                newOptions.wrap = false;
            }
            axNL.post(`/api/v2/materials`, {
                filter: filter,
                // page: page,
                limit: 6,
                // sort: sort,
                options: newOptions,
            })
                .then((response) => {
                    dispatch({
                        type: GET_BEST_SELLERS,
                        payload: response.data
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_BEST_SELLERS,
                        payload: []
                    });
                    resolve([]);
                })
        })
    }
}

export function getProducts(page, limit, clear = true, options = null) {
    return (dispatch, getState, { axios }) => {
        if (clear) {
            dispatch({
                type: GET_MATERIALS,
                payload: []
            });
        }
        dispatch({
            type: ADD_WISHLIST,
            payload: null
        });
        dispatch({
            type: DELETE_WISHLIST,
            payload: null
        })
        const filter = getState().materials.filter;
        const sort = getState().materials.sort;
        const newOptions = options ? Object.assign({}, options) : {}
        if (filter.mat_var_id) {
            newOptions.wrap = false;
            newOptions.sortWithMatVarId = true;
        }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            page: page,
            limit: limit,
            sort: sort,
            options: newOptions,
        })
            .then((response) => {
                dispatch({
                    type: GET_MATERIALS,
                    payload: response.data
                });
            })
            .catch((error) => {

                dispatch({
                    type: GET_MATERIALS_ERR,
                    payload: error.response?.data || "Some error has occurred."
                });
            })
        dispatch(getCountByCategory(filter.brand_id, filter.priceRange, filter.brand_en, filter.rating, filter));
    }
}

export function getProductPromise(mat_id, clear = true, force = false) {
    return (dispatch, getState, { axNL }) => {
        return new Promise(resolve => {
            const matState = getState().materials.material
            if (matState && matState.mat_id === mat_id && !force) {
                return resolve(matState)
            }
            dispatch({
                type: GET_MATERIAL,
                payload: null,
            });
            const filter = getState().materials.filter;
            axNL.get(`/api/v2/material`, {
                params: {
                    mat_id,
                    filter_promo: filter.promotion ? false : true,
                    // brand_en: brand,
                    // mat_name: name
                }
            })
                .then((response) => {
                    dispatch({
                        type: GET_MATERIAL,
                        payload: response.data
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve(error);
                })
        });
    }
}

/**
 * Re-read one product's price without disturbing the rest of the page.
 *
 * `getProductPromise` dispatches `{ type: GET_MATERIAL, payload: null }` before it fetches, which
 * empties `materials.material` and makes the product page re-render as if nothing were loaded —
 * the images, description, reviews and variant selector all tear down and come back. That is the
 * right behaviour when navigating to a *different* product; it is the wrong behaviour when the
 * only thing that changed is a promotion window closing on the product already on screen.
 *
 * This fetches the same endpoint and dispatches `UPDATE_MATERIAL_PRICE`, which merges only the
 * price-bearing fields into the product already in the store (see `material_reducer`). No null
 * dispatch, so nothing blanks.
 *
 * **It does not compute a price.** The backend stays the only place money is calculated (root
 * CLAUDE.md rule 1); this decides only *when* to ask again and *how little* to disturb.
 *
 * @param {string} mat_id - The product's `mat_id`, as used by `getProductPromise`.
 * @returns {Function} A redux-thunk action.
 */
export function refreshMaterialPrice(mat_id) {
    return (dispatch, getState, { axNL }) => {
        return axNL.get(`/api/v2/material`, { params: { mat_id, filter_promo: true } })
            .then((response) => {
                const payload = Array.isArray(response.data) ? response.data[0] : response.data;
                if (!payload) return;

                // Ignore a response that arrived after the customer navigated elsewhere.
                const current = getState().materials.material;
                if (!current || current.mat_id !== payload.mat_id) return;

                dispatch({ type: UPDATE_MATERIAL_PRICE, payload });
            })
            .catch((error) => {
                // A failed price refresh must never blank the page or surface an error to the
                // customer: the price already on screen stays, and the next scheduled attempt
                // tries again. Logged without the payload — an axios rejection carries
                // `error.config.headers`, and root CLAUDE.md rule 4 forbids logging those.
                console.error('price refresh failed for', mat_id, '-', error && error.message);
            });
    };
}

export function getProduct(mat_id, clear = true) {
    // export function getProduct(brand, name, clear = true) {
    return (dispatch, getState, { axios }) => {
        if (clear) {
            dispatch({
                type: GET_MATERIAL,
                payload: null
            });
        }

        axios.get(`/api/v2/material`, {
            headers: {
                // authorization: localStorage.getItem('token')
            },
            params: {
                mat_id
                // brand_en: brand,
                // mat_name: name
            }
        })
            .then((response) => {
                dispatch({
                    type: GET_MATERIAL,
                    payload: response.data
                });
            })
            .catch((error) => {
                console.trace(error);
                // dispatch({
                //     type: GET_MATERIAL_ERR,
                //     payload: error.response.data
                // })
            })
    }
}

export function getCountByCategory(brands = null, price = null, brand_en = null, rating = null, filter = null) {
    return (dispatch, getState, { axios }) => {
        axios.post(`/api/v2/countByCat`, {
            brand_en: brand_en,
            brands: brands,
            price_min: price ? price.min : 0,
            price_max: price ? price.max : 9999999,
            rating: rating,
            filter: filter,
        })
            .then((response) => {
                dispatch({
                    type: COUNT_MATERIALS,
                    payload: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: COUNT_MATERIALS,
                    payload: []
                });
            })
    }
}

export function prePostCommentMaterial(mat_no, mat_var_id, comment, image, rate, so_no = null, id = null) {
    return (dispatch) => {
        if (id) {
            return dispatch(editCommentMaterial(mat_no, mat_var_id, comment, image, rate, so_no, id))
        } else {
            return dispatch(postCommentMaterial(mat_no, mat_var_id, comment, image, rate, so_no))
        }
    }

}

export function postCommentMaterial(mat_no, mat_var_id, comment, image, rate, so_no = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: POST_COMMENT_MATERIAL,
            payload: null
        });
        axios.post(`/api/v2/material/comment`, {
            mat_no, mat_var_id, comment, image, rate, so_no
        })
            .then((response) => {
                dispatch({
                    type: POST_COMMENT_MATERIAL,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: POST_COMMENT_MATERIAL,
                    payload: false
                });
            });
    }
}

export function editCommentMaterial(mat_no, mat_var_id, comment, image, rate, so_no = null, id) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: POST_COMMENT_MATERIAL,
            payload: null
        });
        axios.post(`/api/v2/material/edit_comment`, {
            mat_no, mat_var_id, comment, image, rating: rate, so_no, id
        })
            .then((response) => {
                dispatch({
                    type: POST_COMMENT_MATERIAL,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: POST_COMMENT_MATERIAL,
                    payload: false
                });
            });
    }
}

export function deleteComment(mat_no, id) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: DELETE_COMMENT,
            payload: null
        });
        axios.post(`/api/v2/material/del_comment`, {
            mat_no,
            id
        })
            .then((response) => {
                dispatch({
                    type: DELETE_COMMENT,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_COMMENT,
                    payload: false
                });
            });
    }
}

export function postRateMaterial(mat_no, rate) {
    return (dispatch, getState, { axios }) => {
        if (rate === 0) {
            return;
        }
        dispatch({
            type: POST_RATE_MATERIAL,
            payload: null
        });
        axios.post(`/api/v2/material/rate`, {
            mat_no, rate
        })
            .then((response) => {
                dispatch({
                    type: POST_RATE_MATERIAL,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: POST_RATE_MATERIAL,
                    payload: false
                });
            });
    }
}

export function setPage(page, brand = null) {
    return (dispatch, getState, { axios }) => {
        const brandTrim = brand ? brand.trim() : null;
        dispatch({
            type: SET_PAGE,
            payload: { page, brand: brandTrim }
        })
    }
}

export function getTopBrandProducts(brand_id) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_TOP_BRAND_MATERIALS,
            payload: [],
        });

        axios.post(`/v2/top_brand_materials`, {
            groupby: 'brand_en',
            brand_id: brand_id,
            limit_each: 4,
        })
            .then((response) => {
                dispatch({
                    type: GET_TOP_BRAND_MATERIALS,
                    payload: response.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_TOP_BRAND_MATERIALS,
                    payload: [],
                });
            })
    }
}

export function getTrendyProducts(mat_var_ids) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_TRENDY_PRODUCTS,
            payload: []
        });

        axios.post(`/api/v2/materials`, {
            filter: { mat_var_id: mat_var_ids },
            options: { wrap: false, sortWithMatVarId: true }
        })
            .then((response) => {
                dispatch({
                    type: GET_TRENDY_PRODUCTS,
                    payload: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_TRENDY_PRODUCTS,
                    payload: []
                })
            })
    }
}

export function getMaterialCommentByOrder(so_no, mat_no, mat_var_id) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_COMMENT_ORDER,
            so_no, mat_no, mat_var_id,
            payload: null
        })

        axios.post(`/api/v2/material/retrieve_comment`, {
            so_no, mat_no, mat_var_id
        })
            .then((response) => {
                dispatch({
                    type: GET_COMMENT_ORDER,
                    so_no, mat_no, mat_var_id,
                    payload: response.data
                })
            })
            .catch((err) => {
                dispatch({
                    type: GET_COMMENT_ORDER,
                    so_no, mat_no, mat_var_id,
                    payload: null
                })
            })
    }
}

export function getPromotionSectionBestSeller() {
    return (dispatch, getState, { axios }) => {
        // const filter = getState().materials.filter;
        const options = {}
        const filter = { promotion: ["p001", "p002", "p003", "p004", "p005", "p006"], discount_amount: 0.5, discount_unit: "p", p004_option: { buy: 1, get: 1 } }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: 'best_sellers' },
            options: options,
            limit: 18,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_1,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_1,
                    payload: []
                })
            })
    }
}

export function getPromotionBOGOSectionMakeup() {
    return (dispatch, getState, { axios }) => {
        // const filter = {mat_var_id: _.shuffle([261, 2870, 4302, 1711, 1704, 258, 260, 1349, 6719, 5247, 1347, 2874, 1690, 1712, 715, 799, 2873, 3033, 111, 110])}
        // const options = {wrap: false, sortWithMatVarId: true}
        const filter = { promotion: [0, 0, 0, "p004", 0], p004_option: { buy: 1, get: 1 }, cat1_id: 11 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            // options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_2,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_2,
                    payload: []
                })
            })
    }
}

export function getPromotionBOGOSectionSkincare() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, 0, "p004", 0], p004_option: { buy: 1, get: 1 }, cat1_id: 12 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_3,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_3,
                    payload: []
                })
            })
    }
}

export function getPromotionDiscountSectionPerfume() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, "p003", 0, 0], cat1_id: 16 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_4,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_4,
                    payload: []
                })
            })
    }
}

export function getPromotionDiscountSectionMakeup() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, "p003", 0, 0], cat1_id: 11 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_5,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_5,
                    payload: []
                })
            })
    }
}

export function getPromotionDiscountSectionSkincare() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, "p003", 0, 0], cat1_id: 12 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_6,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_6,
                    payload: []
                })
            })
    }
}

export function getPromotionBuyMoreSectionSkincare() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: ["p001", 0, 0, 0, 0], cat1_id: 12 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_7,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_7,
                    payload: []
                })
            })
    }
}

export function getPromotionBuyMoreSectionMakeup() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: ["p001", 0, 0, 0, 0], cat1_id: 11 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_8,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_8,
                    payload: []
                })
            })
    }
}

export function getPromotionPackSectionMakeup() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, 0, 0, "p005", 0] }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_9,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_9,
                    payload: []
                })
            })
    }
}

export function getPromotionPackSectionSkincare() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, 0, 0, "p005", 0], cat1_id: 12 }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            sort: { value: "best_sellers" },
            options: options,
            limit: 6,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_10,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_10,
                    payload: []
                })
            })
    }
}

export function getPromotionSectionPerfume() {
    return (dispatch, getState, { axios }) => {
        const options = { wrap: false, sortWithMatVarId: true }
        const filter = { mat_var_id: [2917, 3760, 3748, 3377, 3414, 2923, 3747, 3739, 3398, 3722, 3701, 3432, 3001, 2995, 2880] }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            limit: filter.mat_var_id.length,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_5,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_5,
                    payload: []
                })
            })
    }
}

export function getPromotionSectionLuxury() {
    return (dispatch, getState, { axios }) => {
        const options = { wrap: false, sortWithMatVarId: true }
        const filter = { mat_var_id: [6700, 880, 6698, 8488, 8431, 8428, 6696, 899] }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            limit: filter.mat_var_id.length,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_6,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_6,
                    payload: []
                })
            })
    }
}

export function getPromotionSectionMask() {
    return (dispatch, getState, { axios }) => {
        // const options = {wrap: false, sortWithMatVarId: true}
        const options = {}
        const filter = { promotion: [0, 0, "p003", "p004", 0], discount_amount: 0.5, discount_unit: "p", p004_option: { buy: 1, get: 1 }, cat1_id: 12, cat2_id: 1, cat3_id: 2 }
        // const filter = {mat_var_id: [1615, 183, 1836, 1609, 270, 45, 7073, 2780, 190]}
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            sort: { value: "new_arrivals" },
            limit: 18
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_7,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_7,
                    payload: []
                })
            })
    }
}

export function getPromotionSectionMakeup() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, "p003", "p004", 0], discount_amount: 0.5, discount_unit: "p", p004_option: { buy: 1, get: 1 }, cat1_id: 11 }
        // const filter = {mat_var_id: [1031, 1963, 5274, 1920, 176, 3955, 1024, 1976, 1387, 2553, 8424, 2145, 2454, 278, 1971, 686, 3838, 2440, 832, 1865, 717, 3850, 7355, 3777, 4024, 9, 2009]}
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            limit: 18,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_8,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_8,
                    payload: []
                })
            })
    }
}

export function getPromotionSectionExclusive() {
    return (dispatch, getState, { axios }) => {
        const options = { wrap: false, sortWithMatVarId: true }
        const filter = { mat_var_id: [6857, 7372, 8177, 7031, 7146, 8274, 7112, 1620, 8262, 8275, 6855, 7019] }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            limit: filter.mat_var_id.length,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_9,
                    payload: response.data.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION_9,
                    payload: []
                })
            })
    }
}

export function getPromotionProducts() {
    return (dispatch, getState, { axios }) => {
        const options = {}
        const filter = { promotion: [0, 0, "p003", "p004", 0], discount_amount: 0.5, discount_unit: "p", p004_option: { buy: 1, get: 1 } }
        axios.post(`/api/v2/materials`, {
            filter: filter,
            options: options,
            sort: { value: "new_arrivals" },
            limit: 20,
        })
            .then((response) => {
                dispatch({
                    type: GET_PROMOTION_SECTION,
                    payload: _.shuffle(response.data.data)
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_PROMOTION_SECTION,
                    payload: []
                })
            })
    }
}

export function testPro() {
    return (dispatch, getState, { axios }) => {
        axios.post(`/test_pro`, {
            limit: 2
        })
            .then((response) => {
                // console.log(response.data)
                let test_pro_data = []
                Object.keys(response.data.results).forEach((key) => {
                    // console.log(key)
                    // console.log(response.data.results[key].data)
                    test_pro_data.push(...response.data.results[key].data)
                })
                // console.log(test_pro_data)
                dispatch({
                    type: TEST_PRO,
                    payload: test_pro_data
                })
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: TEST_PRO,
                    payload: []
                })
            })
    }
}